var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('soupe-ui-table',{staticClass:"hero-body px-0 py-0",attrs:{"columns":_vm.columns,"fixedLeftColumns":1,"fixedRightColumns":2,"records":_vm.records,"selectionConfigs":_vm.selectionConfigs,"pageSizeInBottom":"","paging":""}})}
var staticRenderFns = []

export { render, staticRenderFns }